var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.showOverlay,"opacity":_vm.opacity}},[(_vm.isMobile)?_c('v-row',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.$strings.spinner))]):_vm._e(),_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }